'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getVideoThumbnail;

var _getVideoId = require('get-video-id');

var _getVideoId2 = _interopRequireDefault(_getVideoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getYoutubeThumbnail(id) {
  return 'https://img.youtube.com/vi/' + id + '/0.jpg';
}

function getVideoThumbnail(string) {
  var videoId = (0, _getVideoId2.default)(string);

  switch (videoId.service) {
    case 'youtube':
      return getYoutubeThumbnail(videoId.id);
    default:
  }

  return string;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/getVideoThumbnail.js
// module id = 1162
// module chunks = 0